import SelectFromRegistry from "../SelectFromRegistry";
import {useStationRegistryQuery} from "./query";
import {useTranslation} from "react-i18next";


const StationTypeSelect = ({value, onChange, ...props}) => {
    const stationRegistryQuery = useStationRegistryQuery();
    const stationTypeRegistry = stationRegistryQuery.data?.stationTypeRegistry || [];
    const {t} = useTranslation("inputs");

    return <SelectFromRegistry value={stationRegistryQuery.isLoading ? "" : value}
                               onChange={onChange}
                               registry={stationTypeRegistry}
                               label={t("stationTypeSelect.label")}
                               {...props} />
}


export default StationTypeSelect;